// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TGetCustomizableMesasagesResponsePayload,
  TGetCustomizableMessagesByRegionRequestPayload,
  TGetCustomizableMessagesByRegionResponsePayload,
  TGetCustomizableMessagesRequestPayload,
  TGetProjectPublicSettingsRequestPayload,
  TGetProjectPublicSettingsResponsePayload,
  TGetProjectThemeRequestPayload,
  TGetProjectThemeResponsePayload,
  TGetSuggestedQuestionsRequestPayload,
  TGetSuggestedQuestionsResponsePayload,
  TSetCompanyNameRequestPayload,
  TSetCompanyNameResponsePayload,
  TSetCustomizableMessagesForRegionRequestPayload,
  TSetCustomizableMessagesForRegionResponsePayload,
  TSetFlagNotificationSettingsRequestPayload,
  TSetFlagNotificationSettingsResponsePayload,
  TSetProjectThemeAndLogoRequest,
  TSetProjectThemeAndLogoResponsePayload,
  TSetProjectThemeRequestPayload,
  TSetProjectThemeResponsePayload,
  TSetSuggestedQuestionsRequestPayload,
  TSetSuggestedQuestionsResponsePayload,
} from './project-settings.types.ts';

export const createProjectSettingsApi = (transport: TApiTransport) => ({
  /** Returns the project's customizable messages */
  getCustomizableMessages: (
    payload: TGetCustomizableMessagesRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetCustomizableMessagesRequestPayload,
      TGetCustomizableMesasagesResponsePayload
    >('/get_customizable_messages', payload, options),

  /** Returns customizable messages for a region */
  getCustomizableMessagesByRegion: (
    payload: TGetCustomizableMessagesByRegionRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetCustomizableMessagesByRegionRequestPayload,
      TGetCustomizableMessagesByRegionResponsePayload
    >('/get_customizable_messages_by_region', payload, options),

  /** Returns the project's public settings */
  getProjectPublicSettings: (
    payload: TGetProjectPublicSettingsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetProjectPublicSettingsRequestPayload,
      TGetProjectPublicSettingsResponsePayload
    >('/get_project_public_settings', payload, options),

  /** Returns the project's theme */
  getProjectTheme: (
    payload: TGetProjectThemeRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetProjectThemeRequestPayload,
      TGetProjectThemeResponsePayload
    >('/get_project_theme', payload, options),

  /** Returns the project's suggested questions, the default list and the per region overrides */
  getSuggestedQuestions: (
    payload: TGetSuggestedQuestionsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetSuggestedQuestionsRequestPayload,
      TGetSuggestedQuestionsResponsePayload
    >('/get_suggested_questions', payload, options),

  /** Sets the project's company name */
  setCompanyName: (
    payload: TSetCompanyNameRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TSetCompanyNameRequestPayload,
      TSetCompanyNameResponsePayload
    >('/set_company_name', payload, options),

  /** Sets customizable messages for a region */
  setCustomizableMessagesForRegion: (
    payload: TSetCustomizableMessagesForRegionRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TSetCustomizableMessagesForRegionRequestPayload,
      TSetCustomizableMessagesForRegionResponsePayload
    >('/set_customizable_messages_for_region', payload, options),

  /** Sets the project's flag notification recipients and toggles */
  setFlagNotificationSettings: (
    payload: TSetFlagNotificationSettingsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TSetFlagNotificationSettingsRequestPayload,
      TSetFlagNotificationSettingsResponsePayload
    >('/set_flag_notification_settings', payload, options),

  /** Sets the project's theme */
  setProjectTheme: (
    payload: TSetProjectThemeRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TSetProjectThemeRequestPayload,
      TSetProjectThemeResponsePayload
    >('/set_project_theme', payload, options),

  /** Sets the project's theme and logo */
  setProjectThemeAndLogo: (
    payload: TSetProjectThemeAndLogoRequest,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TSetProjectThemeAndLogoRequest,
      TSetProjectThemeAndLogoResponsePayload
    >('/set_project_theme_and_logo', payload, {
      ...options,
      contentType: 'multipart/form-data',
    }),

  /** Replaces the suggested questions of one region or of the default list */
  setSuggestedQuestions: (
    payload: TSetSuggestedQuestionsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TSetSuggestedQuestionsRequestPayload,
      TSetSuggestedQuestionsResponsePayload
    >('/set_suggested_questions', payload, options),
});
